var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "voting-area" }, [
    _c("div", { staticClass: "voting-box" }, [
      _c(
        "div",
        { staticClass: "text-area" },
        [
          _c("h1", [
            _vm._v("\n        " + _vm._s(_vm.$t("voting.header")) + "\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("voting.description")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _vm.user !== null
            ? _c(
                "nuxt-link",
                {
                  staticClass: "btn cyan",
                  attrs: { to: _vm.localePath("/voting/proposals/create") },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("voting.create_proposal")) +
                      "\n      "
                  ),
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn cyan",
                  on: { click: _vm.openConnectWallet },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("voting.connect_to_make")) +
                      "\n      "
                  ),
                ]
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "image-area" }, [
        _c("div", { staticClass: "picture" }, [
          _c(
            "picture",
            [
              _c("source", {
                attrs: { srcset: "/img/new/voting.webp", type: "image/webp" },
              }),
              _vm._v(" "),
              _c("nuxt-img", {
                attrs: {
                  fit: "inside",
                  width: "836",
                  sizes: "sm:300px md:400px lg:500px xl:500px xxl:600px",
                  src: "/img/new/voting.png",
                  alt: "Governance DAO voting using $SPLASHIE on Defi Pool Finance",
                  title: "$SPLASHIE governance",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cyan-cloud" }, [_c("CloudCyanVotingRight")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "cyan-cloud2" }, [_c("CloudCyanVotingLeft")], 1),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "h2" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("voting.propossals")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "filter-row" }, [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          {
            class: { "filter-item": true, active: _vm.filter.type === "core" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.changeType("core")
              },
            },
          },
          [
            _c("Verified"),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("voting.core")) + "\n        "
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              "filter-item": true,
              active: _vm.filter.type === "community",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.changeType("community")
              },
            },
          },
          [
            _c("Community"),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("voting.community")) +
                  "\n        "
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { "filter-item": true, active: _vm.filter.type === "all" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.changeType("all")
              },
            },
          },
          [
            _c("List"),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("voting.all")) + "\n        "
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "radio-input" }, [
          _c("input", {
            attrs: {
              id: "period_now",
              value: "now",
              type: "radio",
              name: "period",
            },
            domProps: { checked: _vm.filter.status === "active" },
            on: {
              input: function ($event) {
                return _vm.changePeriod("active")
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "period_now" } }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("voting.vote_now")) + "\n        "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-input" }, [
          _c("input", {
            attrs: {
              id: "period_soon",
              value: "soon",
              type: "radio",
              name: "period",
            },
            domProps: { checked: _vm.filter.status === "soon" },
            on: {
              input: function ($event) {
                return _vm.changePeriod("soon")
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "period_soon" } }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("voting.soon")) + "\n        "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-input" }, [
          _c("input", {
            attrs: {
              id: "period_closed",
              value: "closed",
              type: "radio",
              name: "period",
            },
            domProps: { checked: _vm.filter.status === "closed" },
            on: {
              input: function ($event) {
                return _vm.changePeriod("closed")
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "period_closed" } }, [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("voting.closed")) + "\n        "
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "votings" }, [
      _vm.proposals.length > 0 && !_vm.proposalsLoading
        ? _c(
            "div",
            { staticClass: "voting-table" },
            _vm._l(_vm.proposals, function (proposal, ind) {
              return _c(
                "div",
                { key: ind, staticClass: "voting-row" },
                [
                  _c("div", { staticClass: "voting-title" }, [
                    _vm._v(
                      "\n          " + _vm._s(proposal.title) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ends" }, [
                    _c("i", { staticClass: "bx bx-calendar" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("voting.ends_in")) +
                        "\n          " +
                        _vm._s(_vm.$beautifyDate(proposal.expires)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "statuses" }, [
                    proposal.type === "core"
                      ? _c(
                          "div",
                          { staticClass: "status core" },
                          [
                            _c("Verified"),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("voting.core")) +
                                "\n          "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    proposal.type === "community"
                      ? _c(
                          "div",
                          { staticClass: "status community" },
                          [
                            _c("Community"),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("voting.community")) +
                                "\n          "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "btn cyan open",
                      attrs: {
                        to: _vm.localePath(
                          "/voting/proposals/" + proposal.snapshot
                        ),
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("voting.vote")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm.proposalsLoading
        ? _c(
            "div",
            { staticClass: "voting-table" },
            _vm._l(5, function (ind) {
              return _c(
                "div",
                { key: ind, staticClass: "voting-row" },
                [
                  _c("Skeleton", {
                    staticClass: "voting-title",
                    attrs: { width: "150px", height: "22px" },
                  }),
                  _vm._v(" "),
                  _c("Skeleton", {
                    staticClass: "ends",
                    attrs: { width: "100px", height: "14px" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "statuses" },
                    [
                      _c("Skeleton", {
                        staticStyle: { "margin-right": "1rem" },
                        attrs: { width: "75px", height: "18px" },
                      }),
                      _vm._v(" "),
                      _c("Skeleton", {
                        attrs: { width: "75px", height: "18px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("Skeleton", {
                    staticClass: "open",
                    attrs: { width: "50px", height: "20px" },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _c("div", { staticClass: "voting-table empty-area" }, [
            _c("div", { staticClass: "h4" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("voting.no_proposals")) +
                  "\n      "
              ),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }